import React from 'react';

const Award: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4974_59296)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2ZM4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8C20 12.4183 16.4183 16 12 16C7.58172 16 4 12.4183 4 8Z"
          fill="#00A868"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6585 12.8897C16.206 12.817 16.7087 13.202 16.7813 13.7495L17.9913 22.8695C18.0418 23.2501 17.8699 23.626 17.549 23.8368C17.2281 24.0476 16.8148 24.056 16.4855 23.8585L12 21.1672L7.51452 23.8585C7.18525 24.056 6.77193 24.0476 6.45099 23.8368C6.13004 23.6259 5.95817 23.25 6.00873 22.8693L7.21873 13.7593C7.29145 13.2118 7.79421 12.827 8.34169 12.8997C8.88917 12.9724 9.27403 13.4752 9.20132 14.0226L8.26447 21.0761L11.4855 19.1435C11.8022 18.9535 12.1978 18.9535 12.5145 19.1435L15.7359 21.0763L14.7987 14.0125C14.7261 13.465 15.111 12.9623 15.6585 12.8897Z"
          fill="#00A868"
        />
      </g>
      <defs>
        <clipPath id="clip0_4974_59296">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Award;
